import { Truck } from "lucide-react";
import React, { useState } from "react";
import { Badge } from "../../../../../components/ui/common/badge";
import { SelectOptionList, TransportRoute } from "../types/chemicalRecords.types";
import ChemicalRouteRow from "./ChemicalRouteRow";
import TransportRouteDraft from "./TransportRouteDraft";

interface ChemicalRouteSectionProps {
  chemId: string;
  routes: TransportRoute[];
  transportOptions: SelectOptionList;
  transportLabelMap: Record<string, string>;
  onAddRoute: (chemId: string, route: Pick<TransportRoute, "type" | "distance">) => void;
  onUpdateRoute: (chemId: string, routeId: string, patch: Partial<TransportRoute>) => void;
  onRemoveRoute: (chemId: string, routeId: string) => void;
}

/** Transport-routes sub-list nested inside an editing chemical record. */
const ChemicalRouteSection: React.FC<ChemicalRouteSectionProps> = ({
  chemId,
  routes,
  transportOptions,
  transportLabelMap,
  onAddRoute,
  onUpdateRoute,
  onRemoveRoute
}) => {
  const [editingRouteId, setEditingRouteId] = useState<string | null>(null);

  return (
    <div className="tw-border tw-border-dashed tw-border-muted-foreground/30 tw-rounded-md tw-p-2.5 tw-space-y-2">
      <div className="tw-flex tw-items-center tw-justify-between">
        <div className="tw-flex tw-items-center tw-gap-1.5">
          <Truck className="tw-h-3 tw-w-3 tw-text-muted-foreground" />
          <span className="tw-text-[10px] tw-font-medium tw-text-foreground">Transport Routes</span>
          {routes.length > 0 && (
            <Badge variant="outline" className="tw-text-[9px] tw-h-4 tw-px-1">
              {routes.length}
            </Badge>
          )}
        </div>
      </div>

      {routes.map(route => (
        <ChemicalRouteRow
          key={route.id}
          route={route}
          chemId={chemId}
          transportOptions={transportOptions}
          transportLabelMap={transportLabelMap}
          isEditing={editingRouteId === route.id}
          onEdit={() => setEditingRouteId(route.id)}
          onDone={() => setEditingRouteId(null)}
          onUpdateRoute={onUpdateRoute}
          onRemoveRoute={onRemoveRoute}
        />
      ))}

      <div className="tw-pt-1">
        <p className="tw-text-[9px] tw-text-muted-foreground tw-mb-1">Add transport route</p>
        <TransportRouteDraft chemId={chemId} transportOptions={transportOptions} onAddRoute={onAddRoute} />
      </div>
    </div>
  );
};

export default ChemicalRouteSection;
